import { UniversalWindow } from '@/components/ui/UniversalWindow';
import { AutoSelectionForm } from '@/components/autoforms/AutoSelectionForm';

// ============================================================================
// PollClientPickDialog — обязательный шаг ВЫБОРА КЛИЕНТА перед прохождением
// psy-методики: выбранный клиент записывается в протокол как объект
// тестирования (subject_id), «Пользователь» (entity_id) остаётся тем, кто
// проводит. Справочник psy_clients — штатная форма выбора (единый механизм
// AutoSelectionForm): поиск, карточки, права/владелец — всё серверное.
// ============================================================================

export function PollClientPickDialog({ onSelect, onClose }: {
  onSelect: (id: string, name: string) => void;
  onClose: () => void;
}) {
  return (
    <UniversalWindow
      open
      onClose={onClose}
      title="Выбор клиента"
      width="w-[min(760px,94vw)]"
      height="h-[min(76vh,92vh)]"
      resizable={false}
    >
      <div className="flex flex-col h-full min-h-0">
        <div className="px-3 py-2 text-[11px] text-muted-foreground border-b shrink-0">
          Выберите клиента — он будет записан в протокол как объект тестирования.
        </div>
        <div className="flex-1 min-h-0 flex">
          <AutoSelectionForm objectType="catalog" objectName="psy_clients" onSelect={onSelect} />
        </div>
      </div>
    </UniversalWindow>
  );
}
